import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { SectionHead } from "../components/SectionHead";
import { LOCATIONS, IMG } from "../data/content";
import { track } from "../lib/api";

export default function Locations() {
  return (
    <main>
      <PageHero
        eyebrow="Locations"
        title="Creating Experiences Across AP & Telangana"
        description="Based in Vijayawada, Mega Celebrity Events supports suitable events across Andhra Pradesh and Telangana through event-specific planning and coordination."
        image={IMG.audience}
      />
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#C9A55C]/12 border border-[#C9A55C]/12">
            {LOCATIONS.map((l, i) => (
              <Reveal key={l.slug} delay={(i % 3) * 0.07}>
                <Link
                  to={`/locations/${l.slug}`}
                  onClick={() => track("location_view", { city: l.slug })}
                  className="group bg-[#0D1018] p-10 block h-full hover:bg-[#11141f] transition-colors duration-500"
                  data-testid={`locations-card-${l.slug}`}
                >
                  <MapPin size={18} className="text-[#C9A55C]" />
                  <h2 className="font-display text-2xl text-[#F3EEE5] mt-5 group-hover:text-[#C9A55C] transition-colors duration-300">{l.name}</h2>
                  <p className="mt-3 text-sm text-[#A9ABB2] leading-relaxed">{l.note}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[0.65rem] uppercase tracking-[0.25em] text-[#C9A55C]">
                    Explore <ArrowRight size={12} />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="mt-8 text-xs text-[#A9ABB2]/70">Other locations subject to requirements and availability.</p>
            <Link to="/plan-your-event" className="btn-gold mt-6 inline-flex" data-testid="locations-cta-btn">Check Availability in Your City</Link>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
